import { ModalObjectProps } from '../../types'
import { ConfirmationModal } from '../modals/ConfirmationModal'
import { useModals } from '../../store'

export const RequestContextModal: React.FC<ModalObjectProps> = ({ id, context }) => {
  const { closeModal } = useModals()
  const request = context as { message: string; onAllow: () => void; onDeny: () => void }

  const onAllow = () => {
    if (typeof request.onAllow === 'function') {
      request.onAllow()
    }
    closeModal(id)
  }

  const onDeny = () => {
    if (typeof request.onDeny === 'function') {
      request.onDeny()
    }
    closeModal(id)
  }

  return (
    <ConfirmationModal
      id={id}
      header={'Requesting Additional Context'}
      primaryAction={{ label: 'Continue', onClick: onAllow, variant: 'primary' }}
      secondaryAction={{ label: 'Cancel', onClick: onDeny, variant: 'ghost-neutral' }}
    >
      {request.message}
    </ConfirmationModal>
  )
}
